<template>
  <div class="LaptopTags">
    <Tag
      v-if="hasProsCons"
      class="success">
      <Icon name="paragraph" />
      {{ $t('pros', [prosCount]) }}
      &amp;
      {{ $t('cons', [consCount]) }}
    </Tag>
    <Tag
      v-for="{ label, url } in links"
      :key="url"
      class="warning">
      <Icon name="open" />
      {{ label }}
    </Tag>
    <Tag
      v-for="{ siteName, url } in reviews"
      :key="url"
      class="info">
      <Icon name="star-o" />
      {{ siteName }}
    </Tag>
    <Tag
      v-if="laptop.isArchived"
      class="danger">
      <Icon name="lock" />
      {{ $t('archived') }}
    </Tag>
    <Tag
      v-if="laptop.checkedAt"
      class="success">
      <Icon name="check" />
      {{ $t('reviewed') }}
    </Tag>
  </div>
</template>

<script>
import { chain as flatMap, length, pipe, prop, propOr } from 'rambda'

const getProsConsCount = (key, laptops) => pipe(
  propOr([], 'reviewsExternal'),
  flatMap(prop(key)),
  length,
)(laptops)

export default {
  props: {
    laptop: { type: Object, required: true },
  },
  computed: {
    hasProsCons() {
      return !!(this.prosCount + this.consCount)
    },
    consCount() {
      return getProsConsCount('cons', this.laptop)
    },
    prosCount() {
      return getProsConsCount('pros', this.laptop)
    },
    links() {
      return this.laptop.linksExternal || []
    },
    reviews() {
      return this.laptop.reviewsExternal || []
    },
  },
}
</script>

<style lang="scss">
.LaptopTags {
  > .Tag:not(:last-of-type) {
    margin-right: $uh;
  }
}
</style>

<i18n>
{
  "en": {
    "archived": "Archived",
    "reviewed": "Checked",
    "cons": "{0} cons",
    "pros": "{0} pros"
  }
}
</i18n>
